export const environment = {
  ENV: 'prod',
  production: true,

  version: require('../../package.json').version,

  encrypted: false,
  devFeatures: false,
  adatak: '',
  bdatak: '',
  payemntKey: 'AL@722hbajc.%gc1234',

  // This property enable/disable jwt decode token mocking
  isMock: false,
  cookieOption: {
    secure: false,
  },

  // APP ID for Intercom
  APP_ID: 'a540xj2u',

  api_base_url: 'https://api2.myautoleap.com/api/v1',
  socketUrl: 'https://api2.myautoleap.com',
  app_base_url: 'https://app2.myautoleap.com/',
  app2_base_url: 'https://app.myautoleap.com/',
  alpServicesUrl: 'https://services2.myautoleap.com',
  corporate_app_base_url: 'http://dashboard.myautoleap.com/',
  partnerapi_base_url: 'https://partnerapi.myautoleap.com/v1/app',
  ALP_SERVICES_ENABLE: 'true',

  // App tool
  app_tool_base_url: 'https://apptoolsapi.myautoleap.com/api/v1',

  // Site settings
  site: 'prod2',

  // Quickbooks links
  quickbooks_base_url: 'https://qbo.intuit.com/app',
  quickbooks_payment_method: 'https://qbo.intuit.com/app/paymentmethods',

  // Payrix links
  payrix_base_url: 'https://portal.payrix.com',
  payrix_external_script: 'https://api.payrix.com',

  mitchell1_external_script: 'https://intents.mitchell1.com/api/script/v1/integrationclient',
  onesignal_external_script: '',
  onesignal_api_key: '',
};
